import { TFunction } from 'i18next'

import { sortOptions } from 'entities/kyrgyzstan/model/search/sort'

import type { RealtyType } from 'shared/api/kyrgyzstan/search'

interface GetFilterDisplayTextProps {
  sort: string
  realty_type_ids?: number[]
  realtyTypes: RealtyType[]
  t: TFunction
}

export const getFilterDisplayText = ({
  sort,
  realty_type_ids,
  realtyTypes,
  t,
}: GetFilterDisplayTextProps) => {
  const sortText = (() => {
    const sortOption = sortOptions.find((opt) => opt.value === sort)

    return sortOption ? t(sortOption.label) : ''
  })()

  const filtersText = (() => {
    if (!realty_type_ids || realty_type_ids.length === 0) return ''

    const selectedTypes = realty_type_ids
      .map((id) => realtyTypes.find((type) => type.id === id))
      .filter((type): type is RealtyType => type !== undefined)

    if (selectedTypes.length === 0) return ''
    if (selectedTypes.length === 1) return selectedTypes[0].name

    return `${selectedTypes[0].name} +${selectedTypes.length - 1}`
  })()

  return {
    sort: sortText,
    filters: filtersText,
  }
}
